const {
  WHITE_COLOR_NAME,
  RIVERSTONE_COLOR_NAME,
  PROJECTS_BLUE_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  LIGHT_PROJECTS_BLUE_COLOR_NAME,
  LIGHT_MARKETING_RED_COLOR_NAME,
  LIGHT_CRM_GREEN_COLOR_NAME,
  LIGHT_DEV_ORANGE_COLOR_NAME,
  LIGHT_WORK_OS_IRIS_COLOR_NAME,
  DARK_PROJECTS_BLUE_COLOR_NAME,
  DARK_MARKETING_RED_COLOR_NAME,
  DARK_CRM_GREEN_COLOR_NAME,
  DARK_DEV_ORANGE_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME,
  SPACE_BLUE_COLOR_NAME,
  BACKGROUND_GRAY_COLOR_NAME,
  BLACK_COLOR_NAME,
  DODGER_BLUE_COLOR_NAME,
  BLUE_COLOR_NAME,
  SPACE_BLUE_GRADIANT_COLOR_NAME,
  SPACE_BLUE_VIDEO_ONLY_COLOR_NAME,
  SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME
} = require("../styles/color-consts");

const colorOptions = [
  { value: "brand-red", label: "Red" },
  { value: "brand-enterprise-dark", label: "Dark Enterprise" },
  { value: "brand-green", label: "Green" },
  { value: "brand-purple", label: "Purple" },
  { value: "brand-pink", label: "Pink" },
  { value: "brand-blue", label: "Blue" },
  { value: "brand-iris", label: "Iris" },
  { value: "brand-light-blue", label: "Light Blue" },
  { value: "brand-dark-blue", label: "Dark Blue" },
  { value: "transparent", label: "Transparent" },
  { value: "snow", label: "Snow" },
  { value: "purple", label: "Purple" },
  { value: "iris", label: "Iris" },
  { value: "royal", label: "Royal" },
  { value: "green", label: "Green" },
  { value: "yellow", label: "Yellow" },
  { value: RIVERSTONE_COLOR_NAME, label: "Riverstone" },
  { value: "pink", label: "Pink" },
  { value: BLUE_COLOR_NAME, label: "Blue" },
  { value: "enterprise", label: "Enterprise Blue" },
  { value: "gradiant-gray", label: "Gradiant Gray" },
  { value: "gradiant-pink", label: "Gradiant Pink" },
  { value: DODGER_BLUE_COLOR_NAME, label: "Dodger Blue" },
  { value: "light-blue", label: "Light Blue" },
  { value: "green-2", label: "Green" },
  { value: "dark-green", label: "Grass Green" },
  { value: "bright-green", label: "Bright Green" },
  { value: "saladish", label: "Saladish" },
  { value: "dark-orange", label: "Dark Orange" },
  { value: "brand-yellow", label: "Egg Yolk" },
  { value: "red", label: "Dark Red" },
  { value: "sofia-pink", label: "Sofia Pink" },
  { value: "lipstick", label: "Lipstick" },
  { value: "dark-purple", label: "Dark purple" },
  { value: "purple-v2", label: "Purple" },
  { value: "orange", label: "Orange" },
  { value: "dark-blue-v2", label: "Dark Blue" },
  { value: "light-blue-v2", label: "Light Blue" },
  { value: "chill-blue", label: "Chill Blue" },
  { value: "silver", label: "Explosive" },
  { value: "brand-gray", label: "American Gray" },
  { value: BLACK_COLOR_NAME, label: "Blackish" },
  { value: WHITE_COLOR_NAME, label: "White" },
  { value: "brown", label: "Brown" },
  { value: "sunset", label: "Sunset" },
  { value: "bubble", label: "Bubble" },
  { value: "peach", label: "Peach" },
  { value: "berry", label: "Berry" },
  { value: "winter", label: "Winter" },
  { value: "river", label: "River" },
  { value: "navy", label: "Navy" },
  { value: "aquamarine", label: "Aquamarine" },
  { value: "indigo", label: "Indigo" },
  { value: "dark-indigo", label: "Dark Indigo" },
  { value: MARKETING_RED_COLOR_NAME, label: "Marketing red" },
  { value: CRM_GREEN_COLOR_NAME, label: "CRM green" },
  { value: PROJECTS_BLUE_COLOR_NAME, label: "Projects blue" },
  { value: DEV_ORANGE_COLOR_NAME, label: "Software orange" },
  { value: WORK_OS_IRIS_COLOR_NAME, label: "Work OS Iris" },
  { value: LIGHT_MARKETING_RED_COLOR_NAME, label: "Marketing red - light" },
  { value: LIGHT_CRM_GREEN_COLOR_NAME, label: "CRM green - light" },
  { value: LIGHT_PROJECTS_BLUE_COLOR_NAME, label: "Projects blue - light" },
  { value: LIGHT_DEV_ORANGE_COLOR_NAME, label: "Software orange - light" },
  { value: LIGHT_WORK_OS_IRIS_COLOR_NAME, label: "Work OS Iris - light" },
  { value: DARK_MARKETING_RED_COLOR_NAME, label: "Marketing red - dark" },
  { value: DARK_CRM_GREEN_COLOR_NAME, label: "CRM green - dark" },
  { value: DARK_PROJECTS_BLUE_COLOR_NAME, label: "Projects blue - dark" },
  { value: DARK_DEV_ORANGE_COLOR_NAME, label: "Software orange - dark" },
  { value: DARK_WORK_OS_IRIS_COLOR_NAME, label: "Work OS Iris - dark" },
  { value: SPACE_BLUE_COLOR_NAME, label: "Space blue" },
  { value: BACKGROUND_GRAY_COLOR_NAME, label: "Background gray" },
  { value: SPACE_BLUE_GRADIANT_COLOR_NAME, label: "Space blue gradiant" },
  { value: SPACE_BLUE_VIDEO_ONLY_COLOR_NAME, label: "Don't use - Space blue video only" },
  { value: SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME, label: "Don't use - Space blue video only - desktop" }
];

const productsColorOptions = [
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  PROJECTS_BLUE_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME
];

const productColorWithUndertoneOptions = [
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  PROJECTS_BLUE_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  LIGHT_MARKETING_RED_COLOR_NAME,
  LIGHT_CRM_GREEN_COLOR_NAME,
  LIGHT_PROJECTS_BLUE_COLOR_NAME,
  LIGHT_DEV_ORANGE_COLOR_NAME,
  LIGHT_WORK_OS_IRIS_COLOR_NAME,
  DARK_MARKETING_RED_COLOR_NAME,
  DARK_CRM_GREEN_COLOR_NAME,
  DARK_PROJECTS_BLUE_COLOR_NAME,
  DARK_DEV_ORANGE_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME
];

const mainColorOptions = [SPACE_BLUE_COLOR_NAME, ...productsColorOptions];

const titleColorOptions = [BLACK_COLOR_NAME, WHITE_COLOR_NAME, ...mainColorOptions];
const textColorOptions = [BLACK_COLOR_NAME, WHITE_COLOR_NAME, SPACE_BLUE_COLOR_NAME];

const signupButtonColorOptions = [WORK_OS_IRIS_COLOR_NAME, WHITE_COLOR_NAME, SPACE_BLUE_COLOR_NAME, BLACK_COLOR_NAME];

const tagsSupportedColors = [
  "green-2",
  "dark-green",
  "bright-green",
  "saladish",
  "dark-orange",
  "brand-yellow",
  "red",
  "sofia-pink",
  "lipstick",
  "dark-purple",
  "purple-v2",
  "orange",
  "dark-blue-v2",
  "light-blue-v2",
  "chill-blue",
  "silver",
  "brand-gray",
  "black",
  "brown",
  "sunset",
  "bubble",
  "peach",
  "berry",
  "winter",
  "river",
  "navy",
  "aquamarine",
  "indigo",
  "dark-indigo",
  WORK_OS_IRIS_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  PROJECTS_BLUE_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME,
  LIGHT_WORK_OS_IRIS_COLOR_NAME,
  LIGHT_MARKETING_RED_COLOR_NAME,
  LIGHT_PROJECTS_BLUE_COLOR_NAME,
  LIGHT_CRM_GREEN_COLOR_NAME,
  LIGHT_DEV_ORANGE_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME,
  DARK_MARKETING_RED_COLOR_NAME,
  DARK_PROJECTS_BLUE_COLOR_NAME,
  DARK_CRM_GREEN_COLOR_NAME,
  DARK_DEV_ORANGE_COLOR_NAME
];

module.exports = {
  colorOptions,
  tagsSupportedColors,
  titleColorOptions,
  productsColorOptions,
  productColorWithUndertoneOptions,
  mainColorOptions,
  textColorOptions,
  signupButtonColorOptions
};
